export default "__VITE_ASSET__Qmkr$g8A__"